import { post } from "network";

export const subscribeApi = async ({ email }: { email: string }) => {
  return post({
    route: "/api/v1/subscribeMe",
    data: JSON.stringify({ email }),
    config: {
      headers: {
        "Content-type": "application/json",
      },
    },
  });
};

export const contactApi = async (raw: { name: string; email: string; message: string; intrested_in: string; project_budget: string }) => {
  return post({
    route: "/api/v1/contact",
    data: JSON.stringify(raw),
    config: {
      headers: {
        "Content-type": "application/json",
      },
    },
  });
};

export const sendResetEmailApi = async ({ email }: { email: string }) => {
  return post({
    route: "/api/v1/sendResetEmail",
    data: JSON.stringify({ email }),
    config: {
      headers: {
        "Content-type": "application/json",
      },
    },
  });
};

export const resetPasswordApi = async (raw: { password: string; hash: string }) => {
  return post({
    route: "/api/v1/resetPassword",
    data: JSON.stringify(raw),
    config: {
      headers: {
        "Content-type": "application/json",
      },
    },
  });
};

export const getUserDetailsApi = async ({ token }: { token: string }) => {
  return post({
    route: `/api/v1/getDetail`,
    data: JSON.stringify({}),
    config: {
      headers: {
        Authorization: "Bearer " + token,
        "Content-type": "application/json",
      },
    },
  });
};

export const updateProfileApi = async ({ token, ...raw }: { token: string; first_name?: string; last_name?: string; profile_pic?: string }) => {
  return post({
    route: `/api/v1/updateProfile`,
    data: JSON.stringify({ ...raw }),
    config: {
      headers: {
        Authorization: "Bearer " + token,
        "Content-type": "application/json",
      },
    },
  });
};
export const getProfilePicSignedurlApi = async ({ token, ...raw }: { token: string; file_name?: string }) => {
  return post({
    route: `/api/v1/getProfileSignedUrl`,
    data: JSON.stringify({ ...raw }),
    config: {
      headers: {
        Authorization: "Bearer " + token,
        "Content-type": "application/json",
      },
    },
  });
};

// deleteAccountRequestApi
export const createDataDeletionRequestApi = async ({ token, reason }: { token: string, reason: string }) => {
  return post({
    route: `/api/v1/createDataDeletionRequest`,
    data: JSON.stringify({ reason }),
    config: {
      headers: {
        Authorization: "Bearer " + token,
        "Content-type": "application/json",
      },
    },
  });
};